import { useEffect } from 'react';
import { matchPath, useLocation } from 'react-router-dom';

export const pageTitles = [
  //User Managements
  { path: '/user-management', title: 'User Management' },
  // Relationship Managers
  { path: '/user-management/relationship-managers', title: 'Relationship Managers' },
  { path: '/user-management/relationship-manager-details', title: 'RM Details' },
  { path: '/user-management/edit-rm-details', title: 'Edit RM Details' },
  { path: '/user-management/invite-rm-details', title: 'Add RM' },
  // AIF Approver
  { path: '/user-management/aif-approver', title: 'Aif Approver' },
  { path: '/user-management/aif-approver-details', title: 'AIF Approver Details' },
  { path: '/user-management/edit-aifapprover', title: 'Edit AIF Approver' },
  { path: '/user-management/add-aif-approver', title: 'Add AIF Approver' },
  //AMC Admin
  { path: '/user-management/amc-admin', title: 'AMC Admin' },
  { path: '/user-management/amc-admin-details', title: 'AMC Admin Details' },
  { path: '/user-management/edit-amc-admin', title: 'Edit AMC Admin' },
  { path: '/user-management/add-amc-admin', title: 'Add AMC Admin' },
  // Trustee
  { path: '/user-management/trustee', title: 'Trustee' },
  { path: '/user-management/edit-trustee', title: 'Edit Trustee Details' },
  { path: '/user-management/trustee-details', title: 'Trustee Details' },
  { path: '/user-management/add-trustee', title: 'Add Trustee' },
  //Investment Managers
  { path: '/user-management/invest-managers', title: 'Investment Managers' },
  { path: '/user-management/Invest-manager-details', title: 'Investment Managers Details' },
  { path: '/user-management/add-Invest-manager', title: 'Add Investment Managers' },
  { path: '/user-management/edit-Invest-manager', title: 'Edit IM Details' },
  //Distributor
  { path: '/user-management/distributor-details', title: 'Distributor Details' },
  { path: '/user-management/edit-distributor', title: 'Edit Distributor Details' },
  { path: '/user-management/add-distributor', title: 'Add Distributor' },
  { path: '/user-management/distributors', title: 'Distributors' },
  { path: '/user-management/distributor/distributors-rm', title: 'Distributors RM' },
  { path: '/user-management/distributor/authorised-signatory', title: 'Authorised Signatory' },
  { path: '/user-management/distributor/add-distributors-rm', title: 'Add Distributor RM' },
  { path: '/user-management/distributor/edit-distributors-rm', title: 'Edit Distributors RM' },
  {
    path: '/user-management/distributor/add-authorised-signatory',
    title: 'Add Authorised Signatory',
  },
  {
    path: '/user-management/distributor/authorised-signatory-details',
    title: 'Authorised Signatory Details',
  },
  {
    path: '/user-management/distributor/edit-authorised-signatory',
    title: 'Edit Authorised Signatory',
  },
  { path: '/user-management/distributor/poa-approver', title: 'POA Approver' },
  { path: '/user-management/distributor/add-poaApprover', title: 'Add POA Approver' },
  { path: '/user-management/distributor/poa-approver-details', title: 'POA Approver Details' },
  { path: '/user-management/distributor/edit-poaApprover', title: 'Edit POA Approver' },

  // Authentication
  { path: '/login', title: 'Login' },
  { path: '/verify-otp', title: 'Verify OTP' },
  //{ path: '/not-authorized', title: 'Not Authorized' },
  { path: '/onboarding/enter-pan-number', title: 'Onboarding Application' },
  { path: '/onboarding/enter-mobile-number', title: 'Enter Mobile Number' },

  // Dashboard
  { path: '/dashboard', title: 'Dashboard' },

  // Total Applications
  { path: '/applications', title: 'Applications' },
  { path: '/kyc-application-preview', title: 'KYC Application Preview' },
  { path: '/kyc-application/personal-details', title: 'Personal Details' },
  { path: '/kyc-application/address-details', title: 'Address Details' },
  { path: '/kyc-application/document-details', title: 'Document Details' },
  // Top up
  { path: '/view-top-up-list', title: 'View Top Up List' },
  { path: '/view-consent-email-list', title: 'Consent Email List' },
  //AIF Edit Application
  {
    path: '/investment-details/edit-application/distributor-details',
    title: 'Distributor Details',
  },
  {
    path: '/investment-details/edit-application/contributor-details',
    title: 'Contributor Details',
  },
  { path: '/investment-details/edit-application/contact-details', title: 'Contact Details' },
  {
    path: '/investment-details/edit-application/additional-KYC-details',
    title: 'Additional KYC Details',
  },
  { path: '/investment-details/edit-application/fatca', title: 'FATCA' },
  { path: '/investment-details/edit-application/nominee-details', title: 'Nominee Details' },
  { path: '/investment-details/edit-application/bank-details', title: 'Bank Details' },
  {
    path: '/investment-details/edit-application/investment-payment-details',
    title: 'Investment Payment Details',
  },
  { path: '/investment-details/edit-application/document-details', title: 'Document Details' },
  { path: `/investment-details/:referenceId/verify-pan`, title: 'Verify Pan' },
  { path: '/investment-details/:referenceId/application-details', title: 'Application Detail' },

  //Individual Application
  { path: '/application/distributor-details', title: 'Distributor Details' },
  { path: '/application/contributor-details', title: 'Contributor Details' },
  { path: '/application/contact-details', title: 'Contact Details' },
  { path: '/application/additional-KYC-details', title: 'Additional KYC Details' },
  { path: '/application/fatca', title: 'FATCA' },
  { path: '/application/bank-details', title: 'Bank Details' },
  { path: '/application/risk-profiles', title: 'Risk Profiles' },
  { path: '/application/nominee-details', title: 'Nominee Details' },
  {
    path: '/application/investment-payment-details',
    title: 'Investment Payment Details',
  },
  { path: '/application/document-details', title: 'Document Details' },
  // Individual Application Preview
  { path: '/application-preview', title: 'Application Preview' },

  // Non Individual Application
  {
    path: '/non-individual-application-preview',
    title: 'Non Individual Application Preview',
  },
  {
    path: '/non-individual-application-details',
    title: 'Non Individual Application Details',
  },
  {
    path: '/non-individual-application/distributor-details',
    title: 'Distributor Details',
  },
  {
    path: '/non-individual-application/contributor-details',
    title: 'Contributor Details',
  },
  {
    path: '/non-individual-application/contact-details',
    title: 'Contact Details',
  },
  {
    path: '/non-individual-application/investment-payment-details',
    title: 'Investment Payment Details',
  },
  {
    path: '/non-individual-application/bank-details',
    title: 'Bank Details',
  },
  {
    path: '/non-individual-application/risk-profiles',
    title: 'Risk Profiles',
  },
  {
    path: '/non-individual-application/document-details',
    title: 'Document Details',
  },
  {
    path: '/non-individual-application/authorised-signatory',
    title: 'Authorised Signatory',
  },
  {
    path: '/non-individual-application/declaration-ubo',
    title: 'UBO Declaration',
  },
  {
    path: '/non-individual-application/fatca',
    title: 'FATCA',
  },

  //Funds setup
  { path: '/funds-setup/fund-list', title: 'Funds List ' },
  { path: '/funds-setup/add-fund', title: 'Add Funds' },
  { path: '/funds-setup/fund-details', title: 'Fund Details' },
  { path: '/funds-setup/edit-fund', title: 'Edit Fund' },
  //Plan
  { path: '/funds-setup/view-plans', title: 'Plans' },
  { path: '/funds-setup/add-plan', title: 'Add Plan' },
  { path: '/funds-setup/plan-details', title: 'Plan Details' },
  { path: '/funds-setup/edit-plan', title: 'Edit Plan' },

  // Reports
  { path: '/reports', title: 'Reports' },

  //User Funds Verification
  {
    path: '/users-funds-verification',
    title: 'Users Funds Verification',
  },

  { path: '/users-funds-verification/usersList', title: 'User List' },
  { path: '/users-funds-verification/user-details', title: 'User Details' },
  { path: '/users-funds-verification/schemesList', title: 'Scheme List' },
  { path: '/users-funds-verification/schemes-details', title: 'Scheme Details' },
  { path: '/users-funds-verification/plansList', title: 'Plan List' },
  { path: '/users-funds-verification/plan-details', title: 'Plan Details' },
  { path: '/users-funds-verification/miscellaneousList', title: 'Miscellaneous List' },

  // Document Setup
  { path: '/documents-setup', title: 'Documents Setup' },

  //Admin Support
  { path: '/admin-support', title: 'Admin Support' },

  //Investor Application
  {
    path: '/investment-details',
    title: 'Investment Details',
  },

  // AIF Approver login
  { path: '/applications-list', title: 'Applications List' },
  { path: '/application-details', title: 'Application Details' },

  { path: '/kyc-applications', title: 'KYC Aplication' },
  { path: '/kyc-onboarding/create', title: 'Create KYC Application' },
  { path: '/create-bulk-funds', title: 'Create Bulk Fund' },

  { path: '/profile', title: 'Profile' },
].sort((a, b) => b.path.length - a.path.length);

const APP_NAME = 'KFintech :: AIF';

export default function PageTitle(): null {
  const location = useLocation();

  useEffect(() => {
    // const matchedRoute = pageTitles.find(({ path }) => location.pathname.startsWith(path));
    const matchedRoute = pageTitles.find(({ path }) =>
      matchPath(location.pathname, {
        path,
        exact: false,
        strict: false,
      })
    );

    document.title = matchedRoute ? `${APP_NAME} - ${matchedRoute.title}` : APP_NAME;
  }, [location.pathname]);

  return null;
}
